import { render } from "./text-facet.vue?vue&type=template&id=accf876a"
import script from "./text-facet.vue?vue&type=script&lang=js"
export * from "./text-facet.vue?vue&type=script&lang=js"

import "./text-facet.vue?vue&type=style&index=0&id=accf876a&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__